import React from "react";
import { Navigate, useLocation } from "react-router";
import { isLoggedIn } from "../services/authSession";

type Props = {
  children: React.ReactElement;
};

export default function RequireAuth({ children }: Props) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
